import { Select, SelectChangeValue } from '@ds-web/components';

import { translations } from '@shippypro/translations_restricted';
import { useTranslation } from 'react-i18next';

type PaginationPageSelectorProps = {
  value: number;
  values?: number[];
  onChange: (value: number) => void;
};

export const PaginationPageSelector = ({
  value,
  values = [10, 25, 50, 100, 250, 500],
  onChange,
}: PaginationPageSelectorProps) => {
  const { t } = useTranslation(),
    perPageTrans = translations.common.table.perPage;

  const options = values.map(v => ({
    label: t(perPageTrans, {
      count: v,
    }),
    value: v,
  }));

  return (
    <Select
      value={{
        label: options.find(option => option.value === value)?.label,
        value: value,
      }}
      onChange={e => onChange(Number((e as SelectChangeValue<string>).value))}
      className="table-per-page-select"
      options={options}
      isSearchable={false}
      menuPlacement="top"
      inline
    />
  );
};
